module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan3-1-955a54bd9afec5930c4492dbffbaf03c.webp";